import {BlockSpacer, currentMedia} from '../../../styledComponents/ResponsiveConvenience'
import styled from 'styled-components'
import {ColumnFlexContainer, LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {RESERVATION_STATUS} from '../../../CodeMaster'
import React, {ReactNode} from 'react'
import {Moment} from 'moment'
import {Nullable} from '../../../app/TypeHelpers'
import {GrayedStatusTag} from '../components/ReservationStatusTag'
import {PlainLinkStyledButton} from '../../../styledComponents/Button'

export interface Props {
    reservationStatus: RESERVATION_STATUS
}

export interface TimeSlot {
    type: 'blank' | 'current' | 'other'
    startDateTime: Moment
    endDateTime: Moment
    reservationStatus: Nullable<RESERVATION_STATUS>,
    ownerName: Nullable<string>
    title: Nullable<string>
}

export const ReservationDurationTD: React.FC<{
    startDate: string,
    startTime: string,
    startIsOutOfDuration: boolean,
    endDate: string,
    endTime: string,
    endIsOutOfDuration: boolean,
}> = props => {
    const {startDate, startTime, startIsOutOfDuration, endDate, endTime, endIsOutOfDuration} = props
    return (
        <ReservationDuration>
            <ReservationDatetime isOutOfDuration={startIsOutOfDuration}>
                <LeftRowFlexContainer>
                    <ReservationDate>{startDate}</ReservationDate>
                    <ReservationTime>{startTime}</ReservationTime>
                </LeftRowFlexContainer>
            </ReservationDatetime>
            <BlockSpacer height={'10px'}/>
            <ReservationDatetime isOutOfDuration={endIsOutOfDuration}>
                <LeftRowFlexContainer>
                    <ReservationDate>{endDate}</ReservationDate>
                    <ReservationTime>{endTime}</ReservationTime>
                </LeftRowFlexContainer>
            </ReservationDatetime>
        </ReservationDuration>
    )
}

export const ReservationDetailTD: React.FC<{ timeSlot: TimeSlot }> = props => {
    const {timeSlot} = props
    const status = timeSlot.reservationStatus === null ? null :
        (<>
            <GrayedStatusTag>{timeSlot.reservationStatus.label}</GrayedStatusTag>
            <BlockSpacer width={'5px'}/>
        </>)
    let title: ReactNode = null
    if (timeSlot.type === 'blank') {
        title = <ReservationTitle>空きあり</ReservationTitle>
    } else if (timeSlot.title !== null) {
        title = <ReservationTitle>{timeSlot.title}</ReservationTitle>
    }
    return (
        <ReservationDetail>
            {
                timeSlot.ownerName !== null &&
                <div>{`${timeSlot.ownerName}が予約しています`}</div>
            }
            {
                timeSlot.ownerName !== null && (status !== null || title !== null) &&
                <BlockSpacer height={'2px'}/>
            }
            {
                (status !== null || title !== null) &&
                <LeftRowFlexContainer>
                    {status}
                    {title}
                </LeftRowFlexContainer>
            }
        </ReservationDetail>
    )
}

export const PanelArea = styled(ColumnFlexContainer)`
  height: 100%;
  align-items: stretch;
  padding-bottom: 30px;
`

export const MainArea = styled.div`
  margin: 0 15px;
`

export const FacilityName = styled.div`
  font-size: ${FontSize.Accent};
  line-height: 1.25;
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
`

export const SubTitle = styled.div`
  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Bold};
  line-height: 25px;
  color: ${Colors.AccentDark};
`

export const TimeSlotTable = styled.table`
  padding: 0;
  border-spacing: 0;
  border-collapse: collapse;
  border-top: solid 1px ${Colors.AccentLight};
  border-bottom: solid 1px ${Colors.AccentLight};
  align-items: center;
  width: 100%;
  table-layout: fixed;
  ${currentMedia.greaterThan('pc')`
      width: 100%;
  `}
  ${currentMedia.lessThan('sp')`
      width: calc(100% + 30px);
      margin-left: -15px;
      margin-right: -15px;
  `};
`

export const TimeSlotTR = styled.tr<{ type: 'blank' | 'current' | 'other' }>`
  box-sizing: content-box;
  height: 50px;
  border-bottom: solid 10px ${Colors.AccentLight};
  background-color: ${props => {
    if (props.type === 'blank') {
        return Colors.Surface
    } else if (props.type === 'current') {
        return 'rgba(245, 166, 35, 0.15)'
    } else {
        return 'rgba(217, 217, 217, 0.25)'
    }
}};
  font-size: ${FontSize.Small};
  font-weight: ${FontWeights.Normal};
  line-height: 18px;
  color: ${Colors.Body};
  &:last-child {
    border-bottom: none;
  }
`

export const ReservationDuration = styled.td`
  width: 76px;
  border-right: dashed 1px ${Colors.AccentLight};
`

export const ReservationDatetime = styled.div<{ isOutOfDuration: boolean }>`
  color: ${props => props.isOutOfDuration ? 'rgba(80, 80, 80, 0.5)' : Colors.Body};
`

export const ReservationDate = styled.div`
  width: 38px;
  margin-right: 4px;
  text-align: right;
`

export const ReservationTime = styled.div`
  width: 36px;
  text-align: left;
`

export const ReservationDetail = styled.td`
  padding-left: 8px;
`

export const ReservationTitle = styled.div`
  font-size: ${FontSize.Middle};
`

export const ViewFacilityInfoButton = styled(PlainLinkStyledButton)`
  margin-left: auto;
  margin-right: auto;
`
